/* Mobile navigation and forest reveal; character greetings live in grova-mascot.js. */
(() => {
  window.GrovaSections.register('grova-footer', '[data-grova-footer]', (root, scope) => {
    const mobile = window.matchMedia('(max-width: 749px)');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const fallbackBackground = root.style.getPropertyValue('--gnf-background');
    function syncBackground() {
      const sections = [...document.querySelectorAll('#MainContent > .shopify-section')];
      const last = sections.reverse().find(section => !section.matches('.section-grova-wave-divider') && !section.hidden);
      const surface = last?.querySelector('[id^="GrovaSection-"], .color-scheme, [class*="color-scheme-"]') || last;
      if (!surface) return;
      const color = getComputedStyle(surface).backgroundColor;
      if (color && color !== 'transparent' && color !== 'rgba(0, 0, 0, 0)') root.style.setProperty('--gnf-background', color);
      else root.style.setProperty('--gnf-background', fallbackBackground);
    }
    syncBackground();
    scope.on(document, 'shopify:section:load', syncBackground);
    scope.on(document, 'shopify:section:reorder', syncBackground);
    const forest = root.querySelector('.gnf__forest-reveal');
    let forestObserver;
    if (forest && window.IntersectionObserver && !reducedMotion.matches) {
      root.classList.add('is-forest-pending');
      forestObserver = new IntersectionObserver(entries => {
        if (!entries.some(entry => entry.isIntersecting)) return;
        root.classList.remove('is-forest-pending');
        root.classList.add('is-forest-visible');
        forestObserver.disconnect();
      }, { threshold: .15 });
      forestObserver.observe(forest);
    }
    const animations = new Map();
    const toggles = [...root.querySelectorAll('[data-footer-toggle]')];
    const panelFor = button => root.querySelector(`[id="${button.getAttribute('aria-controls')}"]`);
    function setExpanded(button, expanded, animate = true) {
      const panel = panelFor(button);
      if (animate && button.getAttribute('aria-expanded') === String(expanded)) return;
      const height = panel.hidden ? 0 : panel.getBoundingClientRect().height;
      animations.get(button)?.cancel();
      animations.delete(button);
      panel.style.removeProperty('overflow');
      button.setAttribute('aria-expanded', String(expanded));
      panel.inert = !expanded;
      if (!animate || !mobile.matches || reducedMotion.matches || !panel.animate) {
        panel.hidden = !expanded;
        return;
      }
      panel.hidden = false;
      panel.style.overflow = 'hidden';
      const animation = panel.animate(
        [{ height: `${height}px` }, { height: expanded ? `${panel.scrollHeight}px` : '0px' }],
        { duration: 280, easing: 'cubic-bezier(.22, .61, .36, 1)', fill: 'both' },
      );
      animations.set(button, animation);
      animation.onfinish = () => {
        if (animations.get(button) !== animation) return;
        panel.hidden = !expanded;
        panel.style.removeProperty('overflow');
        animations.delete(button);
        animation.cancel();
      };
    }
    function syncLayout() {
      toggles.forEach(button => {
        button.disabled = !mobile.matches;
        if (mobile.matches && panelFor(button).contains(document.activeElement)) button.focus({ preventScroll: true });
        setExpanded(button, !mobile.matches, false);
      });
    }
    syncLayout();
    scope.on(mobile, 'change', syncLayout);
    toggles.forEach(button => scope.on(button, 'click', () => {
      if (!mobile.matches) return;
      const expanded = button.getAttribute('aria-expanded') !== 'true';
      toggles.forEach(other => setExpanded(other, other === button && expanded));
    }));
    scope.on(document, 'shopify:block:select', event => {
      const button = toggles.find(item => event.target.contains(item));
      if (button) setExpanded(button, true, false);
    });
    scope.cleanup(() => {
      forestObserver?.disconnect();
      root.classList.remove('is-forest-pending', 'is-forest-visible');
      toggles.forEach(button => { button.disabled = true; setExpanded(button, true, false); });
    });
  });
})();
